<template>
  <div>
    <van-nav-bar
      title="创建订单"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />

    <van-field
      readonly
      clickable
      label="客户"
      :value="form.clientname"
      placeholder="选择客户"
      @click="showPicker = true"
    />

    <van-overlay :show="showPicker" :lock-scroll="false" >

      <div style="width: 90%; height: 90%;margin:0 auto;background-color: aliceblue; position: absolute;top: 5%;left: 5%; overflow-y: auto; overflow-x: hidden;-webkit-overflow-scrolling: touch;" >
         <van-sticky>
          <van-search show-action v-model="clientvalue" placeholder="请输入搜索关键词" @search="getclients"     @cancel="showPicker=false" />
         </van-sticky>
          <van-swipe-cell v-for="item in clients" :key="'client_'+item.id">

            <van-cell :title="item.name"  :value="item.id" :label="item.name" />
            <template #right>
              <van-button square type="primary" text="选择" style="height: 100%;" @click="selectclient(item)"/>
            </template>
          </van-swipe-cell>



      </div>

    </van-overlay>



    <!-- <van-popup v-model="showPicker" round position="bottom">

        <van-picker
          title="客户"
          show-toolbar
          :columns="clients"

          value-key="name"
          @cancel="showPicker = false"
          @confirm="clientConfirm"

        />

    </van-popup> -->

    <van-cell-group>
      <van-field
        v-model="form.lxr"
        label="联系人"
      />
      <van-field
        v-model="form.phone"
        label="电话"
      />
      <van-field
        v-model="form.address"
        label="地址"
      />
      <van-cell >
        <template #title>
          <div style="width: 70px;">配送方式</div>
        </template>
        <template #right-icon>
          <van-radio-group v-model="form['send_type']" direction="horizontal" label="配送方式">
            <van-radio name="市区送货">市区送货</van-radio>
            <van-radio name="物流">物流</van-radio>
            <van-radio name="冻品车">冻品车</van-radio>
            <van-radio name="快递">快递</van-radio>
            <van-radio name="客户自提">客户自提</van-radio>
            <van-radio name="冷链">冷链</van-radio>
          </van-radio-group>
        </template>
      </van-cell>
      <van-cell >
        <template #title>
          <div style="width: 70px;">付款方式</div>
        </template>
        <template #right-icon>
          <van-radio-group v-model="form['pay_type']" direction="horizontal" label="付款方式">
            <van-radio name="预付款">预付款</van-radio>
            <van-radio name="物流代收">物流代收</van-radio>
            <van-radio name="月结">月结</van-radio>
			<van-radio name="周结">周结</van-radio>
            <van-radio name="签字转账">签字转账</van-radio>
            <van-radio name="货到付款">货到付款</van-radio>
            
          </van-radio-group>
        </template>
      </van-cell>
	  <van-cell >
	    <template #title>
	      <div style="width: 70px;">发货费用</div>
	    </template>
	    <template #right-icon>
	      <van-radio-group v-model="form['fahuofeiyong']" direction="horizontal" label="发货费用">
	        <van-radio name="现付">现付</van-radio>
	        <van-radio name="到付">到付</van-radio>
	        
	      </van-radio-group>
	    </template>
	  </van-cell>

    <van-field
      v-model="form.beizhu"
      rows="5"
      autosize
      label="订单备注"
      type="textarea"
      placeholder="请输入留言"

    />
    <van-field v-model="form.total_price" type="number" label="订单总价"  />
    <van-button style="width: 100%;" @click="searchshow=true" plain type="info">点击搜索产品</van-button>

      <van-overlay :show="searchshow" :lock-scroll="false" >

        <div style="width: 90%; height: 90%;margin:0 auto;background-color: aliceblue; position: absolute;top: 5%;left: 5%; overflow-y: auto; overflow-x: hidden;-webkit-overflow-scrolling: touch;" >
           <van-sticky>
            <van-search show-action v-model="pdvalue" placeholder="请输入搜索关键词" @search="searchproducts"     @cancel="onCancel" />
           </van-sticky>
            <van-swipe-cell v-for="item in pdlist" :key="item.id">

              <van-cell :title="item.name"  :value="'库存：'+item.remaining_count" :label="'价格线：'+item.price_line" />
              <template #right>
                <van-button square type="primary" text="选择" style="height: 100%;" @click="selectpd(item)"/>
              </template>
            </van-swipe-cell>



        </div>

      </van-overlay>
      <div style="margin-top: 30px;" v-for="(pd,index) in form.products" :key="index+'_'+pd.id">
        <van-swipe-cell>
          <van-cell-group>

          <van-field label="产品名称" :value="pd.name" readonly />
          <van-field v-model="pd.count" type="digit" label="数量" @change="countchange(pd)"/>
          <van-field v-model="pd.unitprice" type="number" label="单价" @change="danjiachange(pd)" />
          <van-field v-model="pd.xiaoji" type="number" label="小计" @change="xiaojichange(pd)"/>

        </van-cell-group>
        <template #right>
              <van-button square type="danger" text="移除"  style="height:100%" @click="removepd(index)"/>

        </template>


      </van-swipe-cell>
      </div>

    </van-cell-group>
    <van-button  type="danger" text="创建订单" style="width: 100%;margin-top: 40px;"  @click="createorder"/>




  </div>
</template>

<script>
  import * as Api from './api.js'
import { Toast } from 'vant';
import { v4 as uuidv4 } from 'uuid'
  export default {
    name: 'getmyorder',
    data () {
      return {
        clientvalue:'',
        clients:[],
        showPicker: false,
        form:{
          client:'',
          clientname:'',
          lxr:'',
          phone:'',
          address:'',
          send_type:'',
          pay_type:'',
          products:[],
          team:1,
          total_price:0,
          saler:this.$store.state.userinfo.userId,
		  fahuofeiyong:'',
        },
        searchshow:false,
        pdvalue:'',
        pdlist:[]



      }
    },
    created() {
        this.$store.dispatch('getlocaluserinfo')
    },
    methods:{
      getclients(){

        let query={
          saler:this.$store.state.userinfo.userId,
          name:this.clientvalue,
          limit:200
        }
        Api.getclients(query).then(res=>{
          console.log(res)
          this.clients = res.data.data
        })
      },

      onClickLeft(){
        this.$router.back()
        //this.$router.push({path:'/salerviews/myorder'})
      },
      clientConfirm(item){
        console.log(item)
        this.form.client = item.id
        this.form.clientname = item.name
        this.form.lxr = item.lxr
        this.form.phone = item.phone
        this.form.address = item.address
        this.form.send_type = item.sendtype
        this.form.pay_type = item.paytype
		
        this.showPicker=false
      },
      onCancel(){
        this.searchshow = false
      },
      searchproducts(){
        let query={
          limit:999,
          name:this.pdvalue
        }
        Api.getproducts(query).then(res=>{
          this.pdlist = res.data.data
        })
      },
      selectpd(item){
        let pdinfo = {
          id:item.id,
          name:item.name,
          count:1,
          unitprice:item.price_line,
          xiaoji:item.price_line,
          danwei:item.danwei,
          dhcount:0,
          historyprices:[],
          inventoryid:[],
          kucun:item.remaining_count,
          price_line:item.price_line,
          uuid:uuidv4()


        }
        this.form.products.push(pdinfo)
        this.comptotalprice()
        // this.searchshow=false
        Toast({
          message: '添加产品成功！',
          icon: 'like-o',
        });
        console.log(this.form)
      },
      removepd(index){
        this.form.products.splice(index,1)
        this.comptotalprice()

      },
      createorder(){
        Api.createorder(this.form).then(res=>{
          if(res.code==4000){
            Toast({
              message: res.msg,
              icon: 'error',
            });
          }
          if(res.code==2000){
            Toast({
              message: res.msg,
              icon: 'like-oo',
            });
            this.$router.push({path:'/'})
          }
        })
      },
      countchange(pd){
        pd.xiaoji = pd.unitprice * pd.count
        this.comptotalprice()
      },
      danjiachange(pd){
        pd.xiaoji = pd.unitprice * pd.count
        this.comptotalprice()
      },
      comptotalprice(){
        this.form.total_price = 0
        this.form.products.forEach(item=>{
          this.form.total_price += Number(item.xiaoji)
        })
      },
      xiaojichange(){
        this.comptotalprice()
      },
      selectclient(item){

        this.form.client = item.id
        this.form.clientname=item.name
        this.form.lxr = item.lxr
        this.form.address = item.address
        this.form.phone = item.phone
        this.form.send_type = item.send_type
        this.form.pay_type = item.pay_type
        this.showPicker = false
      }
    }
  }

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/salerviews/createorder/index.vue